import "@vitejs/plugin-react/preamble"
import { ToastProvider } from "@heroui/react"
import { createRoot } from "react-dom/client"
import { SignUpPage } from "~/app/pages/SignUpPage"

const el = document.getElementById("app-signup-root")
if (el) {
  createRoot(el).render(
    <>
      <SignUpPage redirectTo={el.dataset.redirect || "/dashboard"} />
      <ToastProvider placement="top" />
    </>,
  )
}
